import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { withTranslation } from 'react-i18next';
import { Row, Col, RFFormInput, Button } from 'virtues-bootstrap';
import { ReactComponent as IconPlusSolid } from 'svg/plus-solid.svg';
import { ReactComponent as Trash } from 'svg/trash.svg';
import { ReactComponent as LightningIcon } from 'svg/bolt-solid.svg';

import AdaptiveDataRow from 'components/DataBlock/AdaptiveDataRow';

import s from './styles.module.scss';

const contentSizesDeviceParams = {
  md: 12,
  lg: 9,
};

const titleSizesDeviceParams = {
  xs: 12,
  md: 12,
  sm: 12,
  lg: 3,
};

class RenderShocks extends PureComponent {
  static propTypes = {
    fields: PropTypes.objectOf(PropTypes.any).isRequired,
    meta: PropTypes.shape({
      error: PropTypes.string,
      submitFailed: PropTypes.bool,
    }).isRequired,
    t: PropTypes.func.isRequired,
  };

  onAddPhoneClick = () => {
    const { fields } = this.props;

    fields.push();
  };

  onRemovePhoneClick = index => {
    const { fields } = this.props;

    fields.remove(index);
  };

  render() {
    const { t, fields } = this.props;

    return (
      <AdaptiveDataRow
        withLabelMargin
        titleSizes={titleSizesDeviceParams}
        contentSizes={contentSizesDeviceParams}
        title={t('reports.recordedShocks')}
        icon={<LightningIcon />}
      >
        {fields.map((field, index) => (
          <div key={field}>
            <Row className={s.shocksBlock}>
              <Col xs={6}>
                <Field
                  component={RFFormInput}
                  name={`${field}.shockDate`}
                  placeholder="MM/DD/YYYY"
                />
              </Col>
              <Col xs={4}>
                <Field component={RFFormInput} name={`${field}.shockHour`} placeholder="HH:mm" />
              </Col>
              <Col>
                {index > 0 && (
                  <div
                    role="button"
                    className={s.deleteIcon}
                    tabIndex={index}
                    onKeyPress={() => this.onRemovePhoneClick(index)}
                    onClick={() => this.onRemovePhoneClick(index)}
                  >
                    <Trash />
                  </div>
                )}
              </Col>
            </Row>
          </div>
        ))}
        {fields.length < 5 && (
          <Button
            className={s.addButton}
            icon={<IconPlusSolid />}
            variant="link"
            onClick={this.onAddPhoneClick}
            size="sm"
            type="button"
          >
            {t('reports.addAnotherShock')}
          </Button>
        )}
      </AdaptiveDataRow>
    );
  }
}

export default withTranslation()(RenderShocks);
